/**
 * Invoice sources that are VOLUNTARY process fees, not member dues.
 *
 * Mirrors User::NON_DUES_INVOICE_SOURCES on the API. Anything listed here is
 * excluded from a member's outstanding balance: it is raised by its own wizard,
 * paid there, and an abandoned one must never read as arrears or block the
 * member from something else.
 *
 * Kept in one place because it was previously copied inline — the copy went
 * stale the moment a new source was added, and a screen that disagrees with the
 * balance calc tells the member they owe money the API says they do not.
 */
export const NON_DUES_INVOICE_SOURCES = [
  "upgrade_fee",
  "upgrade_induction",
  "firm_registration_fee",
  "exam_fee",
  "logbook_assessment",
  "application_fee",
  "event_fee",
  "leave",
] as const;

/** Invoice statuses that still owe money. */
export const OWED_INVOICE_STATUSES = ["unpaid", "pending", "partial"] as const;

/** True when an invoice counts toward the member's outstanding dues. */
export function isOutstandingDuesInvoice(inv: any): boolean {
  return (
    Number(inv?.balance) > 0 &&
    (OWED_INVOICE_STATUSES as readonly string[]).includes(String(inv?.status)) &&
    !(NON_DUES_INVOICE_SOURCES as readonly string[]).includes(String(inv?.source ?? ""))
  );
}
